import { Result } from 'antd';
import { Button } from '../components';
import { useAuth0 } from '@auth0/auth0-react';

const AccessDenied = () => {
  const { logout } = useAuth0();

  return (
    <div>
      <div className="flex justify-end">
        <Button
          type="logout"
          className="text-sm"
          onClick={() =>
            logout({
              logoutParams: {
                returnTo: window.location.origin,
              },
            })
          }
        >
          Logout
        </Button>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center space-y-6">
        <Result
          status="403"
          title={
            <h2 className="text-blue-500 font-semibold tracking-wider">
              Access Denied
            </h2>
          }
          subTitle={
            <div className="text-gray-600 space-y-4">
              <p>You do not have permission to view this page.</p>
              <p className="text-secondary-300">
                If you believe this is an error, please contact{' '}
                <span className="text-blue-600 font-semibold bg-gray-100 px-2 py-1 rounded">
                  support@meocontinuity.com
                </span>
              </p>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default AccessDenied;
